import { render, staticRenderFns } from "./MarketingFeature.vue?vue&type=template&id=e4a364d6&"
import script from "./MarketingFeature.vue?vue&type=script&lang=ts&"
export * from "./MarketingFeature.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingFeature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports